import React, { useEffect, useState, FC } from "react";
import { Row, Col, Table, Pagination, Button,Upload,message, Divider } from "antd";
import { columns, productdatahelper } from "../../helpers/products.helper";
import ConfirmLockModal from "../../components/confirmLockModal";
import { useSearchParams } from "react-router-dom";
import TableForm from "../../components/tableForm";
import ProductInventory from "../../components/productInventory";
import { GetProductList, GetExcelList } from "../../api/product";
import {
  filterParams,
  generateExportedFile,
  convertToServerFormat,
} from "../../helpers/function.helper";
import NavigationMenu from "../../components/navigationMenu";
import { FormattedMessage } from "react-intl";
import { SearchOutlined, FileExcelOutlined ,UploadOutlined} from "@ant-design/icons";
import TableTotalCount from "../../components/tableTotalCount";
import GeneralConditionProductModal from "../../components/generalconditionProductModal";
import type { UploadProps } from 'antd';

const uploadProps: UploadProps = {
  name: 'file',
  action: 'https://aassttiinn.org/api/app/excel/bulk-lock-un-lock-items',
  headers: {
    authorization: 'Bearer '+localStorage.getItem('access_token'),
  },
  onChange(info) {
    if (info.file.status !== 'uploading') {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  },
};



const Product: FC = () => {
  const [searchParams]: any = useSearchParams();
  const [loading, setLoading] = useState<boolean>(true);
  const [excelLoading, setExcelLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [data, setData] = useState<any>([]);
  const [total, setTotal] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(40);
  const [formdata, setFormData] = useState<any>({});
  const [form, setForm] = useState<any>(Object.fromEntries([...searchParams]));
  const [visibleConditionProduct, setVisibleConditionProduct] =
    useState<boolean>(false);
  const [activeId, setActiveId] = useState<number>(0);
  const [visibleConfrimModal, setVisibleConfrimModal] =
    useState<boolean>(false);
  const [info, setInfo] = useState<any>({});
  const [infoGeneralConditionProduct, setInfoGeneralConditionProduct] =
    useState<any>([]);
  const [menuVisible, setMenuVisible] = useState(false);

  useEffect(() => {
    handleProductApi();
  }, [page]);

  useEffect(() => {
    handleProductApi();
  }, [form]);

  const handleConfirm = (isLocked: boolean, id: string, type: string) => {
    setVisibleConfrimModal(true);
    setInfo({ isLocked, id, type });
    let foundIndex = data.findIndex((item: any) => item.id === id);
    setActiveId(foundIndex);
  };

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    handleProductApi(sorter.columnKey, sorter.order);
  };

  const handleProductApi = (sorting?: string, order?: string) => {
    setLoading(true);
    const params = {
      Sorting: sorting,
      order: order === "descend" ? true : false,
      SkipCount: page -1 >0 ? (page - 1) * 40 : 0,
      ProductName: form.productName,
      ManufacturerId: form.ManufacturerId,
      Sku: form.Sku,
      WarehouseId: form.WarehouseId,
      OnlyLockedProducts: form.OnlyLockedProducts,
      OnlyReserevedItems: form.OnlyReserevedItems,
      MinimumQuantity: form.MinimumQuantity,
      MaximumQuantity: form.MaximumQuantity,
      StartDate: form.rangeDate && convertToServerFormat(form.rangeDate[0]),
      EndTime: form.rangeDate && convertToServerFormat(form.rangeDate[1]),
    };
    const fp = filterParams(params);
    setLoading(true);
    GetProductList(fp,pageSize).then((res: any) => {
      setLoading(false);
      if (res.status === 200) {
        setData(productdatahelper(res.data.items, page));
        setTotal(res.data.totalCount);
      }
    });
  };

  const handleGetExcel = () => {
    setExcelLoading(true);
    const params = {
      fromDate: formdata.StartDate,
      toDate: formdata.EndTime,
      manufactureId: formdata.ManufacturerId,
      minQuantity: formdata.MinimumQuantity,
      maxQuantity: formdata.MaximumQuantity,
      isReserved: formdata.OnlyReserevedItems,
      isLocked: formdata.OnlyLockedProducts,
      warehouseId:formdata.WarehouseId
    };
    GetExcelList(params).then((res: any) => {
      setExcelLoading(false);
      if (res.status === 200) {
        generateExportedFile(res.data, "excel");
      }
    });
  };

  const handleConditionProduct = (productName: string) => {
    setVisibleConditionProduct(true);
    setInfoGeneralConditionProduct(productName);
  };
  const handleFormDataChanged = (data:any)=>{
    setFormData(data);
  }
  return (
    <>
      <Row gutter={[0, 24]} justify="center">
        <Col xs={0} md={23}>
          <TableForm setForm={setForm} setFormData={handleFormDataChanged}/>
        </Col>
        <Col xs={2}>
          <Button
            style={{ backgroundColor: "#1d6f42", color: "white" }}
            onClick={handleGetExcel}
            icon={<FileExcelOutlined />}
            loading={excelLoading}
          >
            <span></span>
            <FormattedMessage id="export.excel" />
          </Button>
        </Col>
        <Col xs={21}>
          <Upload {...uploadProps}>
            <Button icon={<UploadOutlined />}>تغییر وضعیت قفل</Button>
          </Upload>
        </Col>
      
        <Col xs={23} md={0}>
          <NavigationMenu visible={menuVisible} setVisible={setMenuVisible}>
            <TableForm setForm={setForm} isMobile  setFormData={handleFormDataChanged}/>
          </NavigationMenu>
        </Col>
        <Col xs={23} md={0}>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={() => setMenuVisible(true)}
            className="d-flex align-items-center"
          >
            <div className="px-2">
              <FormattedMessage id="sku.search" />
            </div>
          </Button>
        </Col>
        <Col span={23}>
          <Table 
            columns={columns(handleConfirm, handleConditionProduct)}
            dataSource={data}
            size="middle"
            pagination={false}
            scroll={{ x: 1500, y: "calc(100vh - 390px)" }}
            onChange={handleTableChange}
            loading={loading}
            expandable={{
              expandedRowRender: (record: any) => {
                return (
                  <>
                    <ProductInventory info={record} />
                  </>
                );
              },
            }}
          />
        </Col>
        <Col span={23}>
          <Row justify="space-between" align="middle">
            <Col>
              <Pagination
                defaultCurrent={1}
                total={total}
                defaultPageSize={40}
                showSizeChanger={true}
                showTitle={true}
                responsive={true}
                showQuickJumper={true}
                simple={false}
                pageSizeOptions={[40,50,100,300]}
                onChange={(number,pageSize) => {setPage(number);setPageSize(pageSize)}}
              />
            </Col>
            <Col>
              <TableTotalCount total={total} />
            </Col>
          </Row>
        </Col>
      </Row>
      <ConfirmLockModal
        info={info}
        visible={visibleConfrimModal}
        setVisible={setVisibleConfrimModal}
      />

      <GeneralConditionProductModal
        visible={visibleConditionProduct}
        setVisible={setVisibleConditionProduct}
        info={infoGeneralConditionProduct}
        setInfo={setInfoGeneralConditionProduct}
      />
    </>
  );
};

export default Product;
